import React from "react";

const LogoBanner = () => null;

export default LogoBanner;
